import React, { Component, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function VerifyEmailComponent(props) {
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();
  useEffect(() => {
    props.onVerifyEmail({
      token: query.get('token'),
    });
  }, []);

  return (
    <div>
      Verify account successfully
    </div>
  );
}

export default VerifyEmailComponent;
